import React from "react";
import NikkiWrapper from "../wrapper/NikkiWrapper";
import "../../../styles/components/selectbook/SelectSteps.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function SelectGender({
  onNext,
  onPrev,
  setGender,
  gender,
  onAlert,
  onSelectSound,
  onNextSound,
  onPrevSound,
}) {
  const { t } = useAppTranslation("components/selectbook/selectGender");
  const genderList = [
    {
      value: "남자",
      labelKey: "genders.male",
      img: "https://storage.googleapis.com/story4u-bucket/mirae_1.png",
    },
    {
      value: "여자",
      labelKey: "genders.female",
      img: "https://storage.googleapis.com/story4u-bucket/mirae_2.png",
    },
  ];

  const handlePrev = () => {
    onPrevSound?.();
    setGender("");
    onPrev();
  };

  const handleNext = () => {
    if (!gender) {
      onAlert(t("alerts.selectGender"));
      return;
    }
    onNextSound?.();
    onNext();
  };

  return (
    <NikkiWrapper
      titleDescription={t("titleDescription")}
      progressValue="40"
      onNext={handleNext}
      onPrev={handlePrev}
      showPrev={true}
      onNextSound={onNextSound}
      onPrevSound={onPrevSound}
    >
      <h3>{t("title")}</h3>
      <div className="divider" />
      <ul className="gender-list">
        {genderList.map((item) => (
          <li
            key={item.value}
            className={gender === item.value ? "action" : ""}
            onClick={() => {
              onSelectSound?.();
              setGender((prev) => (prev === item.value ? "" : item.value));
            }}
          >
            <figure>
              <img src={item.img} alt={t(item.labelKey)} />
            </figure>
            <p>{t(item.labelKey)}</p>
          </li>
        ))}
      </ul>
    </NikkiWrapper>
  );
}
